import React, { useContext, useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from '@material-ui/core/Checkbox';
import Alert from "../../components/Alert";
import ResponseUtils from "../../utils/ResponseUtils";
import { trackPromise } from "react-promise-tracker";

import {
  Box,
  Fab,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Tooltip,
  Button
} from "@material-ui/core/";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import DnerhsApi, { CancelToken } from "../../api/DnerhsApi";
import { Link } from "react-router-dom";
import VisibilityIcon from "@material-ui/icons/Visibility";
import AddIcon from "@material-ui/icons/Add";
import UserContext from "../../context/User/UserContext";
import history from "../../utils/History";
import { getSedeSeleccionada } from "services/UsuarioService";
import Roles from "constants/Roles";

const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(),
  },
  formControl: {
    margin: theme.spacing(2),
    //minWidth: 120,
  },
}));

const List = () => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalElements, setTotalElements] = useState(3);
  const [rows, setRows] = useState([]);
  const [open, setOpen] = React.useState(false);
  const { userData, hasRole } = useContext(UserContext);
  const [status, setStatus] = useState("");

  useEffect(() => {
    const load = () => {
      try {
        loadData({ page, rowsPerPage });
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, [status]);

  const loadData = async ({ page = 0, rowsPerPage = 10 }) => {
    let source = CancelToken.source();
    
    try {
      let url;
      if (hasRole(Roles.ROLE_DNERHS)) {
        if (status === "") {
          url = `/profesional/habilitado/e`;
        } else {
          url = `/profesional/habilitado/${status}`;
        }
      } /*else {
        const datosInstitucion = getSedeSeleccionada();
        if (status === "") {
          url = `/instituciones/formadoras/${datosInstitucion?.formadora?.id}/convenios`;
        } else {
          url = `/instituciones/formadoras/${datosInstitucion?.formadora?.id}/convenios/estado=${status}`;
        }
      }*/
      const response = await DnerhsApi.get(url, {
        cancelToken: source.token,
      });
      console.log("response load data", response);
      const rows = response.data;
      setRows(rows);
      setTotalElements(response.data.length);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangePage = async (event, newPage) => {
    setRows([]);
    try {
      setPage(newPage);
      await loadData({ page: newPage, rowsPerPage });
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeRowsPerPage = async (event) => {
    let rowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(rowsPerPage);
    setRows([]);

    try {
      await loadData({ page, rowsPerPage });
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (event) => {
    setStatus(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const showServerError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }

    Alert.show({
      message,
      type: "error"
    })
  }
  
  const showMessageError = (message) => {
    Alert.show({
      message,
      type: "error"
    })
  }
  const handleChangeConfirmacion = async (event, row) => {
    try {
      let url = "/profesional";

      let payloadUpt = { ...row };
      payloadUpt.habilitado=event.target.checked;
      const result= await trackPromise(DnerhsApi.put(url, {
        ...payloadUpt,
      }));
     /* const result= await trackPromise( DnerhsApi.put(
        `/convenios/practicas/confirmacion/${row.id}?confirmacion=${event.target.checked}`
      ));*/
      if(row.habilitado){     
        Alert.show({
          message: "Profesional no habilitado exitosamente.",
          type: "success",
        });
      }else{
        Alert.show({
          message: "Profesional habilitado exitosamente.",
          type: "success",
        });
      }

      loadData({ page, rowsPerPage });
    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      } else {
        showMessageError(error);
      }
    }
  }
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Paper>
          <Box p={1}>
            <Typography
              variant="h5"
              color="primary"
              align="center"
              className={classes.title}
            >
              Profesionales de Salud
            </Typography>
            <Grid item xs={6}>
              <FormControl
                className={classes.formControl}
                variant="outlined"
                fullWidth
              >
                <InputLabel id="demo-controlled-open-select-label">
                  Registro 
                </InputLabel>
                <Select
                  labelId="demo-controlled-open-select-label"
                  id="demo-controlled-open-select"
                  label="Estado"
                  open={open}
                  onClose={handleClose}
                  onOpen={handleOpen}
                  value={status}
                  onChange={handleChange}
                >
                  <MenuItem value="">
                    <em>Ninguno</em>
                  </MenuItem>
                  <MenuItem
                    value={"T"}
                  >
                    Todos
                  </MenuItem>
                  <MenuItem value={"S"}>
                    Habilitados
                  </MenuItem>
                  <MenuItem
                    value={"N"}
                  >
                   No Habilitados
                  </MenuItem>
                  
                </Select>
              </FormControl>
            </Grid>
            <Table size="small">
              <TableHead>
                <TableRow>
              
                  <TableCell align="left">Nombres</TableCell>
                  <TableCell align="left">Apellidos</TableCell>
                  <TableCell align="left">C.I.</TableCell>
                  <TableCell align="left">Número de Registro</TableCell>
                  <TableCell align="left">Habilitado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow key={index}>
                   
                    <TableCell align="left">
                      {row.nombres}
                    </TableCell>
                    <TableCell align="left">{row.apellidos}</TableCell>
                    <TableCell align="left">{row.cedulaIdentidad}</TableCell>
                    <TableCell align="left">{row.numeroRegistroProfesionalVigente}</TableCell>

                    <TableCell align="left">
                            <Tooltip title="Habilitar" aria-label="habilitar">
                              <Checkbox
                                checked={row.habilitado}
                                onChange={(event) =>
                                  handleChangeConfirmacion(event, row)
                                }
                                inputProps={{
                                  "aria-label": "primary checkbox",
                                }}
                                //disabled={(practicaResponseData.estado === "Práctica cronograma finalizada")? true:false}
                              />
                            </Tooltip>
                          </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[10, 15, 20]}
                    colSpan={6}
                    count={totalElements}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { "aria-label": "Registros por página" },
                      native: false,
                    }}
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}-${to} de ${count}`
                    }
                    labelRowsPerPage="Registros por página"
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
       
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              spacing={2}
              alignItems="center"
            >
              <Grid item>
                <Button
                  variant="contained"
                  color="default"
                 onClick={() => history.goBack()}
                >
                  Atrás
                </Button>
              </Grid>
              {!hasRole(Roles.ROLE_DNERHS) && (<Grid item>
                <Link to="/convenios/crear">
                  <Fab color="primary" aria-label="nuevo">
                    <Tooltip title="Nuevo Convenio" aria-label="nuevo">
                      <AddIcon />
                    </Tooltip>
                  </Fab>
                </Link>
              </Grid>)}
            </Grid>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default List;
